(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[247],{

/***/ "/rmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.mapper.js + 1 modules
var Product_mapper = __webpack_require__("bGCG");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/product-teaser/ProductTeaser.jsx
var ProductTeaser = __webpack_require__("GjC5");

// CONCATENATED MODULE: ./src/client/components/lines/product-summary-line/ProductSummaryLine.jsx

var __jsx = react_default.a.createElement;




var ProductSummaryLine_ProductSummaryLine = function ProductSummaryLine(_ref) {
  var _product$resortId;

  var color = _ref.color,
      config = _ref.config,
      id = _ref.id,
      product = _ref.product;
  return !!product && __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, __jsx(ProductTeaser["a" /* ProductTeaser */], {
    card: {
      heading: {
        iconName: product === null || product === void 0 ? void 0 : (_product$resortId = product.resortId) === null || _product$resortId === void 0 ? void 0 : _product$resortId.toLowerCase(),
        title: product === null || product === void 0 ? void 0 : product.name
      },
      link: {
        url: product === null || product === void 0 ? void 0 : product.href
      },
      text: {
        text: product === null || product === void 0 ? void 0 : product.title
      },
      color: color
    },
    product: Object(Product_mapper["c" /* getProductProps */])({
      config: config,
      product: product
    })
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-summary/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductSummaryLine_ProductSummaryLine);

/***/ })

}]);